import {Arr, Bool, Num, Obj, Opt, OptStr, Str} from '@repo/shared/api/core/api_schema';
import type {SchemaToType} from '@repo/shared/api/core/api_schema';

export type TvDeviceStatus = 'pending' | 'approved' | 'rejected' | 'revoked';

export const TvAccountSchema = Obj({email: Str(), createdAt: Num()});
export type TvAccount = SchemaToType<typeof TvAccountSchema>;

export const TvDeviceSchema = Obj({
  id: Str(),
  requestCode: Str(),
  name: Str(),
  status: Str<TvDeviceStatus>(),
  email: OptStr(),
  createdAt: Num(),
  updatedAt: Num(),
});
export type TvDevice = SchemaToType<typeof TvDeviceSchema>;

export const TvStatusSchema = Obj({
  device: TvDeviceSchema,
  account: Opt(TvAccountSchema),
  pollAfterSeconds: Num(),
});
export type TvStatus = SchemaToType<typeof TvStatusSchema>;

// Device credentials are carried only in Authorization headers, never in API payloads or URLs.
export const TV_API = {
  '/register-device': {POST: {req: Obj({name: Str()}), res: TvStatusSchema}},
  '/device-status': {POST: {req: Obj({}), res: TvStatusSchema}},
  '/session': {POST: {req: Obj({}), res: Obj({account: TvAccountSchema, device: TvDeviceSchema})}},
  '/logout': {POST: {req: Obj({}), res: Obj({loggedOut: Bool()})}},
};

export const TV_ADMIN_API = {
  '/admin/tv/list': {
    POST: {
      req: Obj({kind: Str<'account' | 'device'>(), paginationToken: OptStr()}),
      res: Obj({
        accounts: Arr(TvAccountSchema),
        devices: Arr(TvDeviceSchema),
        paginationToken: OptStr(),
      }),
    },
  },
  '/admin/tv/create-account': {
    POST: {req: Obj({email: Str()}), res: Obj({account: TvAccountSchema})},
  },
  '/admin/tv/approve': {POST: {req: Obj({deviceId: Str(), email: Str()}), res: Obj({})}},
  '/admin/tv/reject': {POST: {req: Obj({deviceId: Str()}), res: Obj({})}},
  '/admin/tv/revoke-device': {POST: {req: Obj({deviceId: Str()}), res: Obj({})}},
  '/admin/tv/logout-account': {POST: {req: Obj({email: Str()}), res: Obj({})}},
};
